import React from "react";
import Modal from "../../../common/Modal";

export default function HistoryModal({ data, accountName, onClose }) {
  return (
    <Modal show={!!data} onClose={onClose}>
      <div className="modal-header">
        <h4 className="modal-title" id="staticBackdropLabel">
          History: {accountName}
        </h4>
        <button
          type="button"
          className="btn-close"
          onClick={onClose}
          aria-label="Close"
        ></button>
      </div>
      <div className="modal-body">
        {data && data.history && data.history.length > 0 && (
          <div>
            {data.history.map((h, i) => (
              <div key={i}>
                <dl className="row g-0 text-start m-0 text-break">
                  <dt className="col-sm-3">Attest Date:</dt>
                  <dd className="col-sm-9">{h["attest-date-time"]}</dd>
                  <dt className="col-sm-3">Review Date:</dt>
                  <dd className="col-sm-9">{h["review-date"]}</dd>
                  <dt className="col-sm-3">Status:</dt>
                  <dd className="col-sm-9">{h.status}</dd>
                  <dt className="col-sm-3">Submitted By:</dt>
                  <dd className="col-sm-9">{h["submitted-by"]}</dd>
                  <dt className="col-sm-3">Accounts:</dt>
                  {Object.keys(h.accounts).map((type, i) => (
                    <div key={i}>
                      <dl className="row g-0 text-start m-0 text-break">
                        <dt className="col-sm-3">Type:</dt>
                        <dd className="col-sm-9">{type}</dd>
                        <dt className="col-sm-3">Identifiers:</dt>
                        <dd className="col-sm-9">
                          {h.accounts[type].map((accountItem, i) => (
                            <span key={i} className="m-1">
                              {accountItem.account}
                              {i !== h.accounts[type].length - 1
                                ? ","
                                : undefined}
                            </span>
                          ))}
                        </dd>
                      </dl>
                    </div>
                  ))}
                  {data.history.length > 1 &&
                    data.history.length - 1 !== i && <hr />}
                </dl>
              </div>
            ))}
          </div>
        )}
      </div>
      <div>
        <div className="modal-footer d-flex justify-content-end bd-highlight">
          <div className="bd-highlight">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
